import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import smoothscroll from "smoothscroll-polyfill";
import ReactGA from "react-ga";
// import api from "./axiosConfig";
import api from "./components/axiosConfig";
// Import your components here
import LandingPage from "./components/LandingPage";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import ForgotPassword from "./components/ForgotPassword";
import Dashboard from "./components/Dashboard";
import ResetPassword from "./components/ResetPassword";
import Report from "./components/Report";
import MiniReport from "./components/MiniReport";
import FeedbackAssistant from "./components/Feedback";
import Credits from "./components/Credits";
import ReportDashboard from "./components/ReportDashboard";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import ReportDemo from "./components/ReportDemo";
import MiniReportDemo from "./components/MiniReportDemo";
import FirstArticle from "./components/blog/first_article";
import SecondArticle from "./components/blog/second_article";
import ThirdArticle from "./components/blog/third_article";
import BlogHub from "./components/BlogHub";
import DoorOpeners from "./components/DoorOpeners";
import FeedbackAISetupAndMonitor from "./components/KeywordAlerts";
import Minuutes from "./components/Minuutes";

import CreateTestForm from "./components/Betterby100CreateTest";
import BetterBy100Marketplace from "./components/Betterby100Marketplace";
import EditTest from "./components/Betterby100EditTest";

import BetterBy100ResultDashboard from "./components/Betterby100ResultDashboard";
import SpotlighteCreate from "./components/SpotlighteCreate";
import SpotlighteList from "./components/SpotlighteList";
import AIMarketGapFinder from "./components/AIMarketGapFinder";
// import WebsiteGenerator from "./components/WebsiteGenerator";
import IdeaSubmissionPage from "./components/WebsiteGenerator";
import PreviewPage from "./components/WebsitePreview";
import LaunchVoteLanding from "./components/LaunchVoteLanding";
import CreateLaunchPage from "./components/CreateLaunchPage";
import FeatureVotingPage from "./components/FeatureVotingPage";
import IdeationDashboard from "./components/IdeationDashboard";
import LeadFinder from "./components/LeadFinder";
import CoreDashboard from "./components/CoreDashboard";
import IdeaToLaunchPlatform from "./components/LandingPage";
import VideoCreator from "./components/VideoCreator";
import VideoLibrary from "./components/VideoLibrary";
import MaintenancePage from "./components/MaintenancePage";
import InsightsTab from "./components/InsightsTab";
import LeadFinderEdit from "./components/LeadFinderEdit";
import OnboardingChecklist from "./components/OnboardingChecklist";
import VoiceAgentUI from "./components/VoiceAgentUI";
import HybridBusinessPlanner from "./components/HybridPlanner";

import BusinessIdeaInput from "./components/BusinessIdeaInput";
import ReportSectionsView from "./components/ReportSectionsView";
import RankFlow from "./components/RankFlow";

import { HelmetProvider } from "react-helmet-async";

// TOOLS
import FreeIdeaValidator from "./components/FreeIdeaValidator";
import FreeIdeaValidatorResultsPage from "./components/FreeIdeaValidatorResultsPage";

const App = () => {
  const [isRestricted, setIsRestricted] = useState(false);
  const [clientIP, setClientIP] = useState(null);
  const ipInfoToken = "54225501c526ff"; // Replace with your ipinfo.io token
  const myIP = "152.58.191.51"; // Replace with your actual IP address

  useEffect(() => {
    // kick off the polyfill!
    smoothscroll.polyfill();

    axios
      .get("https://ipinfo.io?token=54225501c526ff")
      .then((response) => {
        const { country, ip } = response.data;
        // if (["IN", "NG", "PK", "VN"].includes(country) && ip !== myIP) {
        // if (["IN", "NG", "PK", "VN", "BD", "TZ", "IR", "KP"].includes(country) && ip !== myIP) {
        // if (["IN", "NG", "PK", "VN", "BD", "TZ", "IR", "KP"].includes(country) && ip !== myIP) {
        if (["NG", "PK", "VN", "BD", "TZ", "IR", "KP"].includes(country) && ip !== myIP) {
          // if (["NG", "PK"].includes(country) && ip !== myIP) {
          setIsRestricted(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching user location:", error);
      });

    // Track page view on component mount
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  if (isRestricted) {
    return (
      <div>
        Unfortunately, this service/website is not available in your country.
        <br />
        {/* If you think this is an error please contact business@feedbackbyai.com{" "} */}
      </div>
    );
  }

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* <Route path="" element={<LandingPage />} /> */}
          <Route path="" element={<IdeaToLaunchPlatform />} />
          {/* <Route path="" element={<MaintenancePage />} /> */}
          <Route path="/signin/" element={<SignIn />} />
          <Route path="/signup/" element={<SignUp />} />
          <Route path="/forgot-password/" element={<ForgotPassword />} />
          <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
          <Route path="/full-report/:reportId" element={<Report />} />
          <Route path="/mini-report/:reportId" element={<MiniReport />} />
          {/* <Route path="/dashboard/" element={<ReportDashboard />} /> */}
          <Route path="/report/" element={<ReportDashboard />} />
          <Route path="/previewx/" element={<ReportDemo />} />
          <Route path="/minipreview/" element={<MiniReportDemo />} />
          <Route path="/feedback" element={<FeedbackAssistant />} />
          <Route path="/credits/" element={<Credits />} />
          <Route path="/report/" element={<ReportDashboard />} />
          <Route path="/hybrid/" element={<HybridBusinessPlanner />} />
          <Route path="/privacy/" element={<Privacy />} />
          <Route path="/terms/" element={<Terms />} />
          {/* <Route path="/dooropeners/" element={<DoorOpeners />} /> */}
          {/* <Route path="/minuutes/" element={<Minuutes />} /> */}
          <Route path="/spotlighte/create/" element={<SpotlighteCreate />} />
          <Route path="/spotlighte/" element={<SpotlighteList />} />
          <Route path="/aimarketgapfinder/" element={<AIMarketGapFinder />} />
          {/* <Route path="/website/" element={<WebsiteGenerator />} /> */}

          <Route path="/launchvote/" element={<LaunchVoteLanding />} />
          {/* <Route path="/createlaunch/" element={<CreateLaunchPage />} /> */}
          <Route path="/video/" element={<VideoCreator />} />
          <Route path="/featurevoting/:website_id/" element={<FeatureVotingPage />} />

          {/* <Route path="/ideate/" element={<IdeationDashboard />} /> */}
          <Route path="/ideate/" element={<InsightsTab />} />

          <Route path="/dashboard/" element={<CoreDashboard />} />
          <Route path="/video-library" element={<VideoLibrary />} />
          <Route path="/leadfinder/" element={<LeadFinder />} />
          <Route path="/leadfinder/edit/" element={<LeadFinderEdit />} />
          <Route path="/rankflow/" element={<RankFlow />} />
          <Route path="/voiceagent/" element={<VoiceAgentUI />} />

          <Route path="/dynamicreports/" element={<BusinessIdeaInput />} />
          <Route path="/dynamicreports/:reportId" element={<ReportSectionsView />} />

          <Route path="/tools/free-startup-idea-validator/" element={<FreeIdeaValidator />} />
          {/* <Route path="/tools/free-startup-idea-validator/result/:id" element={<FreeIdeaValidator />} /> */}
          {/* <Route path="/ideavalidatorresult/:uuid" element={<FreeIdeaValidatorResultsPage />} /> */}
          <Route path="/ideavalidatorresult/:id" element={<FreeIdeaValidatorResultsPage />} />

          <Route path="/onboarding/" element={<OnboardingChecklist />} />

          {/* <Route path="/website/" element={<IdeaSubmissionPage />} />
        <Route path="/preview/:slug" element={<PreviewPage />} /> */}

          {/* BetterBy100 Marketplace */}

          <Route path="/better/" element={<BetterBy100Marketplace />} />

          <Route path="/better/create" element={<CreateTestForm />} />
          <Route path="/result/:landingPageId" element={<BetterBy100ResultDashboard />} />

          <Route path="/edit/:testId" element={<EditTest />} />

          {/* <Route path="/edit" element={<EditablePage />} /> */}
          {/* <Route path="/audience-finder/" element={<FeedbackAISetupAndMonitor />} /> */}
          <Route path="/blog/" element={<BlogHub />} />
          <Route path="/blog/ai-validate-business-idea-in-seconds/" element={<FirstArticle />} />
          <Route path="/blog/discovering-customer-needs-ai/" element={<SecondArticle />} />
          <Route path="/blog/getting-unbiased-feedback-on-your-business-idea-from-ai-characters/" element={<ThirdArticle />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;
